module.exports = __webpack_public_path__ + "static/media/onboarding.d2b223a0.jpg";